import gsap from "gsap";

// import * as ScrollMagic from "scrollmagic";
// import { ScrollMagicPluginIndicator} from "scrollmagic-plugins";
// ScrollMagicPluginIndicator(ScrollMagic);
import ScrollTrigger from "gsap/ScrollTrigger";
import ScrollToPlugin from 'gsap/ScrollToPlugin';

// import 'module/animation.gsap.js';

// import { ScrollMagicPluginGsap } from "scrollmagic-plugin-gsap";

// ScrollMagicPluginGsap(GSAP);

// import ScrollMagic from 'scrollmagic';

gsap.registerPlugin(ScrollTrigger);

let cx, cy, mouseX, mouseY, posX, posY, clientX, clientY, dx, dy, tiltx, tilty, request, radius, degree;
const body = document.querySelector('body')

cx = window.innerWidth / 2
cy = window.innerHeight / 2

body.addEventListener('mousemove', e => {
    clientX = e.pageX
    clientY = e.pageY

    request = requestAnimationFrame(updateMe)

    mouseCoords(e)
    cursor.classList.remove('hidden')
    follower.classList.remove('hidden')
})

function updateMe() {
    dx     = clientX - cx
    dy     = clientY - cy
    tiltx  = dy / cy
    tilty  = dx / cx
    radius = Math.sqrt(Math.pow(tiltx, 2) + Math.pow(tilty, 2))
    degree = radius * 12
    // gsap.to('body', 1, { transform: `rotate3d( ${tiltx}, ${tilty}, 0, ${degree}deg )` })
}

const cursor   = document.getElementById('cursor'),
    follower = document.getElementById('aura'),
    links    = document.querySelectorAll('.preview-item__image, .barker-news__items, .tile__items')

mouseX = 0, mouseY = 0, posX = 0, posY = 0

function mouseCoords(e) {
    mouseX = e.pageX
    mouseY = e.pageY
}

gsap.to({}, .01, {

    repeat: -1,

    onRepeat: () => {

        posX += (mouseX - posX) / 5
        posY += (mouseY - posY) / 5

        gsap.set(cursor, {
            css: {
                left: mouseX,
                top: mouseY
            }
        })

        gsap.set(follower, {
            css: {
                left: posX - 60,
                top: posY - 60
            }
        })

    }

})

for(let i = 0; i < links.length; i++) {

    links[i].addEventListener('mouseover', () => {
        cursor.classList.add('active')
        follower.classList.add('active')
    })

    links[i].addEventListener('mouseout', () => {
        cursor.classList.remove('active')
        follower.classList.remove('active')
    })

}

body.addEventListener('mouseout', () => {
    cursor.classList.add('hidden')
    follower.classList.add('hidden')
});

document.addEventListener('DOMContentLoaded', () => {

    const sectors =  document.querySelector('.section__sectors');
    if(sectors) {
        sector();
    }
    function sector() {
        const slideCounter = document.querySelectorAll('.accordion2 .accordion__item');
        ScrollTrigger.create({
            trigger: ".sectors2",
            // markers: true,
            start: "top top",
            // end: "bottom bottom",
            // end: "+=1500px",
            end: () => `+=${(slideCounter[0].offsetHeight * .35) * slideCounter.length}px`,
            // end: () => "+=" + (slideCounter.length * 100) + "%",
            pin: true,
            onUpdate: (indicator) => stepSlide(indicator.progress),
        });

        function stepSlide(progress) {
            let stepProgress = progress * 100;
            let percentageStep = 90 / (slideCounter.length - 1);
            let currentSlide = Math.floor(stepProgress / percentageStep);

            if(percentageStep) {
                slideHide(currentSlide)
                slideShow(currentSlide)
            }
        }

        slideShow(0)
        function slideShow(i) {
            slideCounter[i].classList.add('accordion__item--active')
            if(i >= 1) {
                slideCounter[i - 1].classList.add('accordion__item--effect')
                slideCounter[i - 1].classList.remove('accordion__item--active')
            }
        }
        function slideHide(i) {
            if(i + 1 >= slideCounter.length) {

            } else {
                // slideCounter[i + 1].classList.remove('accordion__item--active')
                slideCounter.forEach(item => {
                    item.classList.remove('accordion__item--active')
                })
            }
            slideCounter[i].classList.remove('accordion__item--effect')
        }
    }







    // let sectors =  document.querySelector('.sectors');
    //
    // function sector() {
    //     // let sectors =  document.querySelector('.sectors');
    //     // let accordionItems = document.querySelectorAll(".accordion__item");
    //     let accordionItems = gsap.utils.toArray(".accordion__item");
    //     let controller = new ScrollMagic.Controller();
    //     let controllerItems;
    //     let slides = document.querySelectorAll(".accordion__item");
    //
    //     let triggerStart = .5;
    //     function widthChecked() {
    //         let windowWidth = document.body.clientWidth;
    //
    //         // if (windowWidth <= 640) {
    //         //     triggerStart = .14;
    //         //     controller.destroy(true);
    //         //     controllerItems.destroy(true);
    //         //     fixParallax()
    //         // }
    //         // if (windowWidth > 640) {
    //         //     triggerStart = .2
    //         //     fixParallax()
    //         // }
    //     }
    //     widthChecked();
    //     $(window).on('resize', () => {
    //         widthChecked();
    //     });
    //
    //     let duration = 5;
    //
    //     gsap.to(accordionItems, {
    //         yPercent: -100 * (accordionItems.length - 1),
    //         ease: "none",
    //         // direction: 1,
    //         // delay: 15,
    //         duration: .3,
    //         scrollTrigger: {
    //             trigger: ".sectors",
    //             pin: true,
    //             start: "top top",
    //             scrub: 1,
    //             // end: '+=1000',
    //             end: '+='+(accordionItems.length - 1) * 150,
    //             // end: () => "+=" + accordionItems[0].offsetHeight * accordionItems.length,
    //             // snap: 1 / (accordionItems.length - 1),
    //             snap: {
    //                 snapTo: 1 / (accordionItems.length - 1),
    //                 duration: { min: 0.2, max: .5 },
    //                 delay: .5
    //             },
    //             // markers: true,
    //         }
    //     });
    //     // console.log(accordionItems)
    //     // accordionItems.forEach((item) => {
    //     //
    //     //     gsap.to(item, {
    //     //         yPercent: -100 * (item.length - 1),
    //     //         ease: "none",
    //     //         scrollTrigger: {
    //     //             trigger: item,
    //     //             pin: true,
    //     //             start: "to top",
    //     //             scrub: true,
    //     //             // end: '500',
    //     //             end: () => "+=" + item.offsetHeight,
    //     //             markers: true,
    //     //         }
    //     //     });
    //     // })
    //     //
    //     //
    //     // ScrollTrigger.create({
    //     //     trigger: ".sectors",
    //     //     pin: true,
    //     //     start: "top top",
    //     //     scrub: true,
    //     //     end: () => "+=" + document.querySelector(".sectors").offsetHeight,
    //     //     // end: "+=4000",
    //     //     markers: true,
    //     // });
    //
    //
    //
    //     function parallax() {
    //         let parallaxController = new ScrollMagic.Controller({globalSceneOptions: {triggerHook: "onEnter", duration: "200%"}});
    //
    //         $('.accordion__item').each(function() {
    //             let trig = this.parentNode,
    //                 parallax = this.getAttribute('data-parallax'),
    //                 speed = parallax * 100 + '%';
    //
    //             new ScrollMagic.Scene({triggerElement: trig})
    //                 .setTween(this, {y: speed, ease: Linear.easeNone})
    //                 .addTo(parallaxController);
    //         })
    //     }
    //     // parallax();
    //
    //     function fixParallax() {
    //
    //         let activeSlide = 0;
    //
    //         for (let i=0; i<slides.length-1; i++) {
    //             controllerItems = new ScrollMagic.Controller({
    //                 globalSceneOptions: {
    //                     triggerHook: triggerStart,
    //                     // duration: "360px"
    //                     duration: slides[i].offsetHeight
    //                 }
    //             });
    //             new ScrollMagic.Scene({
    //                 triggerElement: slides[i],
    //                 offset: 0,
    //                 triggerHook: 0.1,
    //             })
    //                 .on("enter", function () {
    //                     slides[i].classList.add('accordion__item--active')
    //                     slides[i].classList.remove('accordion__item--effect')
    //                     activeSlide++
    //                     console.log(activeSlide)
    //                 })
    //                 .on("leave", function () {
    //                     slides[i].classList.remove('accordion__item--active')
    //                     slides[i].classList.add('accordion__item--effect')
    //                     activeSlide--
    //                     console.log(activeSlide)
    //                 })
    //                 .setTween(slides[i] /*.querySelector('.accordion__content') , 0.1 , {y : '0' }*/)
    //                 // .setPin(slides[i], {pushFollowers: false})
    //                 .addIndicators()
    //                 // .setClassToggle(slides[i], 'accordion__item--active')
    //                 .addTo(controllerItems);
    //             // new ScrollMagic.Scene({
    //             //     triggerElement: slides[i],
    //             //     offset: slides[i].offsetHeight,
    //             //     triggerHook: 0.1,
    //             // })
    //             //     .on("enter", function () {
    //             //         slides[i].classList.add('accordion__item--effect')
    //             //         // slides[i].classList.remove('accordion__item--active')
    //             //     })
    //             //     .on("leave", function () {
    //             //         // slides[i].classList.remove('accordion__item--effect')
    //             //         // slides[i].classList.add('accordion__item--effectXXX')
    //             //     })
    //             //     // .setTween(slides[i] /*.querySelector('.accordion__content') , 0.1 , {y : '0' }*/)
    //             //     // .setPin(slides[i], {pushFollowers: false})
    //             //     .addIndicators()
    //             //     // .setClassToggle(slides[i], 'accordion__item--active')
    //             //     .addTo(controllerItems);
    //         }
    //     }
    //     // fixParallax()
    //
    //     function fixHeading() {
    //         let triggerHeight = document.querySelector('.sectors');
    //         let scene = new ScrollMagic.Scene({
    //             triggerElement: '.sectors',
    //             duration: triggerHeight.offsetHeight - slides[slides.length - 1].offsetHeight - 190,
    //             triggerHook: 0
    //
    //         })
    //             .setTween('.sectors .heading')
    //             .setPin('.sectors .heading', {pushFollowers: false})
    //             .addIndicators({ name: "My Indicator" })
    //             .addTo(controller);
    //     }
    //
    //     // fixHeading()
    //
    //     function fixSection(el) {
    //         let triggerHeight = document.querySelector(el);
    //         let scene = new ScrollMagic.Scene({
    //             triggerElement: el,
    //             duration: 0,
    //             triggerHook: 0
    //
    //         })
    //             // .setTween('.sectors .heading')
    //             .setPin(el)
    //             .addIndicators({ name: "My Indicator" })
    //             .addTo(controller);
    //     }
    //
    //     // fixSection(".sectors__wrapper")
    // }
    // if(sectors) {
    //     // sector();
    // }






    // accordionItems.forEach(item => {
    //     let scene = new ScrollMagic.Scene({
    //         triggerElement: item,
    //         duration: "100px",
    //         offset: 0,
    //         triggerHook: .5
    //
    //     })
    //         .setTween(item, {y: "-360px", ease: Linear.easeNone})
    //         .setPin(item)
    //         .addIndicators({ name: "My Indicator" })
    //         .addTo(controller);
    // })


    // if(sectors) {
    //     // sectorInit();
    // }
    function sectorInit() {
        let stopSectors = gsap.timeline({
            scrollTrigger: {
                trigger: sectors,
                start: "top top",
                toggleActions: "play none none reverse",
                markers: true,
                pin: true,
            }
        });
    }


    let hasRun = false;
    let accordionNode = document.querySelector('.accordion');
    if(accordionNode) {
        // scrollAccordionInit()
    }
    function scrollAccordionInit() {
        let accordionItems = document.querySelectorAll(".accordion__item");

        let tl8;
        gsap.utils.toArray(".accordion__item").forEach(function (item) {
            tl8 = gsap.timeline({
                scrollTrigger: {
                    // onEnter: () => { console.log(123); },
                    // onLeave: ({progress, direction, isActive}) => console.log(progress, direction, isActive),
                    // onUpdate: ({progress, direction, isActive}) => console.log(progress, direction, isActive),
                    onSnapComplete: ({ progress, direction, isActive }) =>
                        console.log(progress, direction, isActive),
                    toggleClass: "active",
                    trigger: item,
                    start: "top top+=100",
                    end: "bottom 10%",
                    markers: true,
                    scrub: 1.5,
                    // scrub: true,
                    duration: 5000,
                    pin: true,
                },
                // y: 500,
            });

            // tl8.from(item, {y: 100});
            // tl8.to(item, 1, {yPercent: -100, duration: 1});
            // tl8.fromTo(item, {yPercent: 100}, {yPercent: 0, duration: 1});
            // tl8.fromTo(item, {yPercent: 0}, {yPercent: -100, duration: 1});
                // .to(item, 1, {
                //     y: 0,
                //     opacity: 1,
                //     scale: 1,
                //     ease: "none",
                // })
                // .to(item, 1, {
                //     y: 0,
                //     opacity: 1,
                //     scale: 1,
                //     ease: "none",
                // })
                // .to(item, 1, {
                //     y: -150,
                //     opacity: 0,
                //     scale: 1,
                //     ease: "none",
                // });
        });



        // accordionItems.forEach((item) => {
        //     let animationAccordion = gsap.timeline({
        //         scrollTrigger: {
        //             trigger: item,
        //             start: "top 50%",
        //             // end: "+=2000",
        //             toggleActions: "play reverse none none",
        //             markers: true,
        //             scrub: true,
        //         }
        //     });
        //     animationAccordion.to(item, 1, {
        //         y: 500,
        //         x: 100,
        //         opacity: 1,
        //         scale: 1,
        //         ease: "none",
        //     })
        //         .to(item, 1, {
        //             y: 0,
        //             opacity: 1,
        //             scale: 1,
        //             ease: "none",
        //         })
        //         .to(item, 1, {
        //             y:-500,
        //             opacity: 0,
        //             scale: 1,
        //             ease: "none",
        //         });
        //     // animationAccordion.fromTo(item, {
        //     //         opacity: 0,
        //     //         y: 200,
        //     //         ease: "Back.easeOut"
        //     //     },
        //     //     {
        //     //         // y: 0,
        //     //         opacity: 1,
        //     //         y: 0,
        //     //         delay: .2,
        //     //         duration: .8,
        //     //         ease: "Back.easeOut"
        //     //     });
        //     // ScrollTrigger.create(
        //     //     {
        //     //         trigger: item,
        //     //         start: "top 30%",
        //     //         // end: "bottom 15%",
        //     //         toggleActions: "play reverse none none",
        //     //         onToggle: () => {
        //     //             // $(item).parent().find('.accordion__content').slideToggle(800);
        //     //             $(item)
        //     //         },
        //     //         markers: true,
        //     //         scrub: true,
        //     //     }
        //     // )
        // });
    }


});


